import PaymentLocationModal from './PaymentLocationModal';

export default PaymentLocationModal;
